import React from 'react';
import { ZapIcon, InfoIcon } from 'lucide-react';
/**
 * "Why Generation Matching Matters" — two-column usage guidance block.
 */
export function UsageGuidance() {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 md:p-12 mb-16" data-id="element-318">
      <div className="flex items-center gap-3 mb-8 pb-6 border-b border-gray-100" data-id="element-319">
        <ZapIcon className="w-8 h-8 text-blue-600" data-id="element-320" />
        <h2 className="text-2xl font-black text-gray-900 uppercase tracking-tight" data-id="element-321">
          Why Generation Matching Matters
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-322">
        <div data-id="element-323">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-324">
            The Evolution to Gen 3
          </h3>
          <p className="text-gray-600 leading-relaxed mb-6" data-id="element-325">
            Daedo's Gen 3 system represents a significant leap forward in
            electronic scoring technology. The Gen 3 footgear features updated
            sensor placements and materials designed to work exclusively with
            the new Gen 3 Electronic Protectors (E-Hogu) to ensure the most
            accurate and fair scoring possible.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-326">
            Strict Compatibility
          </h3>
          <p className="text-gray-600 leading-relaxed" data-id="element-327">
            Because the sensor technology has fundamentally changed,{' '}
            <strong className="text-gray-900" data-id="element-328">
              you cannot mix generations
            </strong>
            . Gen 3 footgear must be used with Gen 3 body protectors. Attempting
            to use mismatched gear will result in inaccurate scoring or complete
            failure to register hits.
          </p>
        </div>

        <div data-id="element-329">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-330">
            Forget the Old Charts
          </h3>
          <p className="text-gray-600 leading-relaxed mb-6" data-id="element-331">
            If you've been in Taekwondo for a while, you may remember complex
            charts comparing E-Foot G4, E-Heel, and E-Foot Complete.{' '}
            <strong className="text-gray-900" data-id="element-332">
              Those charts are now obsolete.
            </strong>{' '}
            Today, the only question that matters is:{' '}
            <em className="text-gray-800" data-id="element-333">
              Is your tournament using Gen 2 or Gen 3?
            </em>
          </p>

          <div className="bg-blue-50 rounded-xl p-5 border border-blue-100" data-id="element-334">
            <h4 className="font-bold text-blue-900 mb-2 flex items-center gap-2" data-id="element-335">
              <InfoIcon className="w-4 h-4" data-id="element-336" />
              Before You Buy
            </h4>
            <p className="text-sm text-blue-800 leading-relaxed" data-id="element-337">
              Always confirm with your tournament director or coach which
              generation of Daedo PSS will be used at your upcoming events.
              Buying the wrong generation will prevent you from competing.
            </p>
          </div>
        </div>
      </div>
    </div>;
}